import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-unfold-less-icon',
  templateUrl: 'unfold-less-icon.component.html'
})
export class UnfoldLessIconComponent {
  constructor() {}
}
